import { animate, animation, style, transition, trigger, useAnimation } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef, NgZone, PLATFORM_ID, QueryList, Renderer2, DOCUMENT } from '@angular/core';
import { PrimeNGConfig } from 'prime-ng-old/api';
import { Dialog as DialogBase } from 'prime-ng-old/dialog';
import { FocusTrapModule } from 'prime-ng-old/focustrap';
import { UiIconsModule } from '../icons';
import { UiFooterComponent, UiHeaderComponent } from '../shared';
import * as i0 from "@angular/core";
import * as i1 from "prime-ng-old/api";
import * as i2 from "@angular/common";
import * as i3 from "prime-ng-old/focustrap";
import * as i4 from "../icons/icon.component";
const _c0 = ["*", [["ui-header"]], [["ui-footer"]]];
const _c1 = ["*", "ui-header", "ui-footer"];
const _c2 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) => ({
  "p-dialog-mask": true,
  "p-component-overlay p-component-overlay-enter": a0,
  "p-dialog-mask-scrollblocker": a1,
  "p-dialog-left": a2,
  "p-dialog-right": a3,
  "p-dialog-top": a4,
  "p-dialog-top-left": a5,
  "p-dialog-top-right": a6,
  "p-dialog-bottom": a7,
  "p-dialog-bottom-left": a8,
  "p-dialog-bottom-right": a9
});
const _c3 = (a0, a1, a2, a3) => ({
  "p-dialog p-component": true,
  "p-dialog-rtl": a0,
  "p-dialog-draggable": a1,
  "p-dialog-resizable": a2,
  "p-dialog-maximized": a3
});
const _c4 = (a0, a1) => ({
  transform: a0,
  transition: a1
});
const _c5 = a0 => ({
  value: "visible",
  params: a0
});
const _c6 = () => ({
  "p-dialog-header-icon p-dialog-header-close p-link": true
});
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiDialogComponent_Conditional_0_Conditional_1_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headlessTemplate);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("mousedown", function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_0_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.initResize($event));
    });
    i0.ɵɵelementEnd();
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("id", ctx_r1.getAriaLabelledBy());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("id", ctx_r1.getAriaLabelledBy());
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("keydown.enter", function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_6_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.close($event));
    });
    i0.ɵɵelement(1, "ui-icon", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(3, _c6));
    i0.ɵɵattribute("aria-label", ctx_r1.closeAriaLabel)("tabindex", ctx_r1.closeTabindex);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 2);
    i0.ɵɵlistener("mousedown", function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.initDrag($event));
    });
    i0.ɵɵconditionalCreate(2, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_2_Template, 2, 2, "span", 15);
    i0.ɵɵconditionalCreate(3, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_3_Template, 2, 1, "span", 15);
    i0.ɵɵtemplate(4, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_ng_container_4_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵconditionalCreate(6, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Conditional_6_Template, 2, 4, "button", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.headerFacet && !ctx_r1.headerTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.headerFacet ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.closable ? 6 : -1);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12, 3);
    i0.ɵɵprojection(2, 2);
    i0.ɵɵtemplate(3, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_6_ng_container_3_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_0_Template, 1, 0, "div", 9);
    i0.ɵɵconditionalCreate(1, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_1_Template, 7, 4, "div", 10);
    i0.ɵɵelementStart(2, "div", 11, 1);
    i0.ɵɵprojection(4);
    i0.ɵɵtemplate(5, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_ng_container_5_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Conditional_6_Template, 4, 1, "div", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r1.resizable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showHeader ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.contentStyleClass);
    i0.ɵɵproperty("ngClass", "p-dialog-content padded")("ngStyle", ctx_r1.contentStyle);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.contentTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footerFacet || ctx_r1.footerTemplate ? 6 : -1);
  }
}
function UiDialogComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7, 0);
    i0.ɵɵlistener("@animation.start", function UiDialogComponent_Conditional_0_Conditional_1_Template_div_animation_animation_start_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAnimationStart($event));
    })("@animation.done", function UiDialogComponent_Conditional_0_Conditional_1_Template_div_animation_animation_done_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAnimationEnd($event));
    });
    i0.ɵɵconditionalCreate(2, UiDialogComponent_Conditional_0_Conditional_1_Conditional_2_Template, 1, 1, "ng-container")(3, UiDialogComponent_Conditional_0_Conditional_1_Conditional_3_Template, 7, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(9, _c3, ctx_r1.rtl, ctx_r1.draggable, ctx_r1.resizable, ctx_r1.maximized))("ngStyle", ctx_r1.style)("pFocusTrapDisabled", ctx_r1.focusTrap === false)("@animation", i0.ɵɵpureFunction1(17, _c5, i0.ɵɵpureFunction2(14, _c4, ctx_r1.transformOptions, ctx_r1.transitionOptions)));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.ariaLabelledBy)("aria-modal", true);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.headlessTemplate ? 2 : 3);
  }
}
function UiDialogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵconditionalCreate(1, UiDialogComponent_Conditional_0_Conditional_1_Template, 4, 19, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.maskStyle);
    i0.ɵɵclassMap(ctx_r1.maskStyleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunctionV(6, _c2, [ctx_r1.modal, ctx_r1.modal || ctx_r1.blockScroll, ctx_r1.position === "left", ctx_r1.position === "right", ctx_r1.position === "top", ctx_r1.position === "topleft" || ctx_r1.position === "top-left", ctx_r1.position === "topright" || ctx_r1.position === "top-right", ctx_r1.position === "bottom", ctx_r1.position === "bottomleft" || ctx_r1.position === "bottom-left", ctx_r1.position === "bottomright" || ctx_r1.position === "bottom-right"]));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.visible ? 1 : -1);
  }
}
const showAnimation = animation([style({
  transform: '{{transform}}',
  opacity: 0
}), animate('{{transition}}')]);
const hideAnimation = animation([animate('{{transition}}', style({
  transform: '{{transform}}',
  opacity: 0
}))]);
export let UiDialogComponent = /*#__PURE__*/(() => {
  class UiDialogComponent extends DialogBase {
    constructor(document, platformId, el, renderer, zone, cd, config) {
      super(document, platformId, el, renderer, zone, cd, config);
      this.el = el;
      this.renderer = renderer;
      this.zone = zone;
      this.config = config;
      this.baseZIndex = 5000;
      this.dismissableMask = true;
      this.modal = true;
    }
    static {
      this.ɵfac = function UiDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiDialogComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.PrimeNGConfig));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiDialogComponent,
        selectors: [["ui-dialog"]],
        contentQueries: function UiDialogComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiHeaderComponent, 4)(dirIndex, UiFooterComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerFacet = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerFacet = _t);
          }
        },
        inputs: {
          baseZIndex: "baseZIndex",
          dismissableMask: "dismissableMask",
          modal: "modal"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c1,
        decls: 1,
        vars: 1,
        consts: [["container", ""], ["content", ""], ["titlebar", ""], ["footer", ""], [3, "class", "style", "ngClass"], [3, "ngClass"], ["pFocusTrap", "", "role", "dialog", 3, "ngClass", "ngStyle", "class", "pFocusTrapDisabled"], ["pFocusTrap", "", "role", "dialog", 3, "ngClass", "ngStyle", "pFocusTrapDisabled"], [4, "ngTemplateOutlet"], [1, "p-resizable-handle", 2, "z-index", "90"], [1, "p-dialog-header"], [3, "ngClass", "ngStyle"], [1, "p-dialog-footer"], [1, "p-resizable-handle", 2, "z-index", "90", 3, "mousedown"], [1, "p-dialog-header", 3, "mousedown"], [1, "p-dialog-title", 3, "id"], [1, "p-dialog-header-icons"], ["type", "button", "pRipple", "", 3, "ngClass"], ["type", "button", "pRipple", "", 3, "click", "keydown.enter", "ngClass"], ["icon", "times"]],
        template: function UiDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵconditionalCreate(0, UiDialogComponent_Conditional_0_Template, 2, 17, "div", 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.maskVisible ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgTemplateOutlet, i2.NgStyle, FocusTrapModule, i3.FocusTrap, UiIconsModule, i4.UiIconComponent],
        styles: ["@layer primeng{.p-dialog-mask{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;pointer-events:none}.p-dialog-mask.p-component-overlay{pointer-events:auto}.p-dialog{display:flex;flex-direction:column;pointer-events:auto;max-height:90%;transform:scale(1);position:relative}.p-dialog-content{overflow-y:auto;flex-grow:1}.p-dialog-header{display:flex;align-items:center;justify-content:space-between;flex-shrink:0}.p-dialog-draggable .p-dialog-header{cursor:move}.p-dialog-footer{flex-shrink:0}.p-dialog .p-dialog-header-icons{display:flex;align-items:center}.p-dialog .p-dialog-header-icon{display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-fluid .p-dialog-footer .p-button{width:auto}.p-dialog-top .p-dialog,.p-dialog-bottom .p-dialog,.p-dialog-left .p-dialog,.p-dialog-right .p-dialog,.p-dialog-top-left .p-dialog,.p-dialog-top-right .p-dialog,.p-dialog-bottom-left .p-dialog,.p-dialog-bottom-right .p-dialog{margin:.75rem;transform:translateZ(0)}.p-dialog-maximized{transition:none;transform:none;width:100vw!important;height:100vh!important;top:0!important;left:0!important;max-height:100%;height:100%}.p-dialog-maximized .p-dialog-content{flex-grow:1}.p-dialog-left{justify-content:flex-start}.p-dialog-right{justify-content:flex-end}.p-dialog-top{align-items:flex-start}.p-dialog-top-left{justify-content:flex-start;align-items:flex-start}.p-dialog-top-right{justify-content:flex-end;align-items:flex-start}.p-dialog-bottom{align-items:flex-end}.p-dialog-bottom-left{justify-content:flex-start;align-items:flex-end}.p-dialog-bottom-right{justify-content:flex-end;align-items:flex-end}.p-dialog .p-resizable-handle{position:absolute;font-size:.1px;display:block;cursor:se-resize;width:12px;height:12px;right:1px;bottom:1px}.p-confirm-dialog .p-dialog-content{display:flex;align-items:center}}.p-dialog-mask{z-index:9000}.p-dialog-mask.p-dialog-mask-invisible{background-color:transparent;pointer-events:none}.p-dialog-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;pointer-events:none}.p-dialog{pointer-events:auto;display:flex;flex-direction:column;width:800px;max-width:90%;border:var(--overlayContentBorder);border-color:var(--overlayContentBorderColor)}.p-dialog{padding:0;box-shadow:var(--dialogShadow)}.p-dialog .p-dialog-header{background-color:var(--panelHeaderAltBgColor);color:var(--panelHeaderAltTextColor);padding:1em;font-weight:400;border-bottom:0 none}.p-dialog .p-dialog-header .p-dialog-title{margin:0;float:none}.p-dialog .p-dialog-header .p-dialog-header-icon{color:var(--panelHeaderIconColor);border:0 none;padding:0;margin-left:.5em;transition:color .3s}.p-dialog .p-dialog-header .p-dialog-header-icon:hover{color:var(--panelHeaderIconHoverColor)}.p-dialog .p-dialog-content{background-color:var(--panelContentBgColor);color:var(--panelContentTextColor);border:var(--overlayContentBorder);border-color:var(--overlayContentBorderColor);padding:0;position:relative}.p-dialog .p-dialog-content.padded{padding:.571em 1em}.p-dialog .p-dialog-footer{border:0;border-color:transparent;border-top:0 none;background-color:var(--panelFooterBgColor);color:var(--panelFooterTextColor);padding:8px 10px;margin:0;text-align:right}.p-dialog .p-dialog-footer button{margin:0 .5em 0 0;width:auto}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('animation', [transition('void => visible', [useAnimation(showAnimation)]), transition('visible => void', [useAnimation(hideAnimation)])])]
        },
        changeDetection: 0
      });
    }
  }
  return UiDialogComponent;
})();
export const UiDialogBundle = [UiDialogComponent, UiFooterComponent, UiHeaderComponent];